module.exports = __webpack_public_path__ + "static/media/pontos.eaf52c90.svg";